import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

const StatBox = ({ title, subtitle, icon, progress, increase }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box width="100%" p="22px">
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Box
            sx={{
              alignItems: "center",
              background: theme.palette.mode === "dark" ? "rgba(244,63,70,0.12)" : "rgba(244,63,70,0.08)",
              border: `1px solid ${theme.palette.mode === "dark" ? "rgba(244,63,70,0.2)" : "rgba(244,63,70,0.14)"}`,
              borderRadius: "10px",
              display: "flex",
              height: 42,
              justifyContent: "center",
              mb: 1.5,
              width: 42,
            }}
          >
            {icon}
          </Box>
          <Typography
            variant="h2"
            sx={{ color: colors.grey[100], lineHeight: 1 }}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(17,19,24,0.08)"}`,
            borderRadius: "999px",
            color: colors.primary[100],
            fontWeight: 800,
            px: 1.2,
            py: 0.4,
          }}
        >
          {Math.round((Number(progress) || 0) * 100)}%
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" mt="12px">
        <Typography variant="h6" sx={{ color: colors.grey[500] }}>
          {subtitle}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: colors.greenAccent[500], fontWeight: 800 }}
        >
          {increase}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatBox;
